import { Component, OnInit, OnDestroy } from '@angular/core';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../common/utils/froala.utils';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { NoteService } from "../../common/services/note.service";
import { LoaderService } from "../../common/services/loader.service";
import { Note } from "../../common/models/note.model";
import { NoteRelatedItemType } from "../../common/models/note_relatedItemType.enum";
import { NoteType } from "../../common/models/note-type.enum";
import { RetentionPolicy } from "../../common/models/retention-policy.model";
import { genId } from "../../core/services/genId";

@Component({
    selector: 'app-well-notes',
    templateUrl: './well-notes.component.html',
    styleUrls: ['./well-notes.component.scss', '../../common/components/notes/notes.component.scss'],
    standalone: false
})
export class WellNotesComponent implements OnInit, OnDestroy {
    static componentName = 'WellNotesComponent';
    
    componentData: any;

    form: FormGroup;

    private _froalaOptions: any = null;
    get froalaOptions(): any {
        if (!this._froalaOptions) {
            let conf = window["PdfConfig"] as any;
            let key = (conf != null) ? conf.editorLicenseKey : "";
            this._froalaOptions = applyFroalaAriaFix({
                heightMax: 500,
                height: 500,
                heightMin: 150,
                key: key,
                typingTimer: 150,
                saveInterval: 0,
                toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough']
            });
        }
        return this._froalaOptions;
    };

    noteType = NoteType;
    subscription: Subscription = new Subscription();
    title: string = "Add Well Notes";

    types: any[] = ["General", "Internal", "Administrative"];

    get wellNotes(): Note[] {
        return this._wellNotes;
    }

    _wellNotes: Note[] = [];

    constructor(private authService: AuthService, private noteService: NoteService,
        private loaderService: LoaderService) { }

    ngOnInit() {
        this.initializeForm();

        let id = this.componentData.data.id;
        if (this.componentData.title) this.title = this.componentData.title;
        if (this.componentData.notes) this._wellNotes = this.componentData.notes;

        this.subscription = this.noteService.getNotes(id, this.componentData.noteType || NoteRelatedItemType.Well)
            .pipe()
            .subscribe(
                (notes: Note[]) => {
                    this._wellNotes = notes;
                },
                (error) => { console.error(error); }
            );
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    public buildNote(text: string, type: number): Note {
        return {
            createdBy: this.authService.User.displayName,
            createdById: this.authService.User.id,
            createdDate: new Date(),
            documentType: 'Note',
            relatedItemId: this.componentData.data.id,
            relatedItemType: this.componentData.data.noteType || NoteRelatedItemType.Well,
            files: [],
            id: genId(),
            isDeleted: false,
            noteId: genId(),
            notes: [],
            priority: 3,
            referenceUri: '',
            retentionPolicy: {} as RetentionPolicy,
            text: text,
            type: type,
            noteUrgency: 0,
        } as Note;
    }

    cancel(): void {
        this.resetForm();
    }

    public initializeForm(): void {
        let formControls = {
            selectedNoteType: new FormControl(-1, [Validators.required, Validators.min(0)]),
            noteText: new FormControl('', [Validators.required])
        };

        this.form = new FormGroup(formControls);
    }

    openReplyForm(form: any): void {
        form.opened = true;
        form.isReplying = true;
        form.replyText = "";
    }

    reply(parentNote: Note, form: any): void {

        this.loaderService.toggleLoader(true);
        let reply = this.buildNote(form.replyText, parentNote.type);
        reply.text = form.replyText;
        reply.type = parentNote.type;
        reply.parentNoteId = parentNote.id;
        reply.referenceUri = parentNote.referenceUri;
        parentNote.notes.push(reply);

        const index = this._wellNotes.findIndex(x => x.id === parentNote.id);
        form.opened = true;
        this.wellNotes[index] = parentNote;

        this.noteService.postNote(reply).subscribe(note => {
            this.loaderService.toggleLoader(false);
            this.noteService.noteAdded$.next(note);
            this.resetReplyForm(form);
        });
    }

    resetForm(): void {
        this.form.reset({ selectedNoteType: -1, noteText: '' });
        this.form.markAsPristine();
        this.form.markAsUntouched();
    }

    resetReplyForm(form: any): void {
        form.replyText = '';
        form.isReplying = false;
        form.isDirty = false
    }

    save(): void {

        this.loaderService.toggleLoader(true);
        const note = this.buildNote(stripFroalaWatermark(this.form.controls['noteText'].value), parseInt(this.form.controls['selectedNoteType'].value));
        note.referenceUri = window.location.href;
        
        this.noteService.postNote(note).subscribe(note => {
            this.loaderService.toggleLoader(false);
            this.wellNotes.unshift(note);
            this.noteService.noteAdded$.next(note);
            this.resetForm();
        },
            (error) => { console.error(error); });
    }
      
};

  
